import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Api from "./Api";
import { Helmet } from "react-helmet";

function SSoft_Help_Hero() {
  const [sectionItems, setSectionItems] = useState([]);
  const activeLang = useSelector((state) => state.content.activeLanguage);

  useEffect(() => {
    const fetchData = async () => {
      const api = new Api();
      const sectionResponse = await api.getSectionDetail({
        language: activeLang,
      });
      const sectionData = sectionResponse;

      setSectionItems(sectionData.data.results[0]);
    };

    fetchData();
  }, [activeLang]);

  let background;
  let title;
  let summary;
  if (sectionItems) {
    const secWidgets = sectionItems.widgets;

    if (secWidgets) {
      secWidgets?.forEach((data, id) => {
        switch (id) {
          case 0:
            background = data.widget_contents[0]?.file_medium;
            break;
          case 1:
            title = data.widget_contents[0]?.content;
            summary = data.widget_contents[1]?.content;
            break;
          default:
            break;
        }
      });
    }
  }

  return (
    <>
      <Helmet>
        {/* ==== BASIC SEO ==== */}
        <title>
          Contact PT Supersoft Sistemindo | Infor SunSystems & Hexagon EAM
          Enterprise Software Solutions
        </title>
        <meta
          name="description"
          content="Get in touch with PT Supersoft Sistemindo for Infor SunSystems, Hexagon EAM, and enterprise software solutions. Contact us for consultations, product demos, pricing details, and technical support for your business needs"
        />

        {/* ==== STRUCTURED DATA / SCHEMA.ORG ==== */}
        <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@graph": [

            {
              "@type": "Organization",
              "@id": "https://ptsupersoft.com/#organization",
              "name": "PT Supersoft Sistemindo",
              "url": "https://ptsupersoft.com/",
              "logo": "https://bzpublishassets.blob.core.windows.net/media/assets/ss-logo-bigger_YTK6vKm.png",
              "description": "PT Supersoft Sistemindo is an IT solutions provider specializing in Infor SunSystems, Hexagon EAM, and enterprise software consulting services in Indonesia.",
              "email": "sales@ptsupersoft.com",
              "telephone": "+62 21 3970 0150",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Jl. RS. Fatmawati Raya No.12",
                "addressLocality": "Jakarta",
                "addressRegion": "DKI Jakarta",
                "addressCountry": "ID"
              },
              "sameAs": [
                "https://www.linkedin.com/company/ptsupersoft/",
                "https://x.com/ptsupersoft"
              ]
            },

            {
              "@type": "WebPage",
              "@id": "https://ptsupersoft.com/help/contact/#webpage",
              "url": "https://ptsupersoft.com/help/contact",
              "name": "Contact Us – PT Supersoft Sistemindo",
              "inLanguage": ["en", "id"],
              "description": "Hubungi PT Supersoft Sistemindo untuk konsultasi solusi TI, SunSystems, Hexagon EAM, dan kebutuhan software perusahaan Anda.",
              "isPartOf": {
                "@id": "https://ptsupersoft.com/#organization"
              },
              "breadcrumb": {
                "@id": "https://ptsupersoft.com/help/contact/#breadcrumb"
              },
              "about": {
                "@id": "https://ptsupersoft.com/#organization"
              }
            },

            {
              "@type": "ContactPage",
              "@id": "https://ptsupersoft.com/help/contact/#contactpage",
              "url": "https://ptsupersoft.com/help/contact",
              "name": "Contact PT Supersoft Sistemindo",
              "description": "Get in touch with PT Supersoft Sistemindo for product inquiries, demos, pricing, and enterprise software consultation.",
              "inLanguage": ["en", "id"],
              "primaryImageOfPage": {
                "@type": "ImageObject",
                "url": "https://bzpublishassets.blob.core.windows.net/media/assets/ss-logo-bigger_YTK6vKm.png"
              }
            },

            {
              "@type": "BreadcrumbList",
              "@id": "https://ptsupersoft.com/help/contact/#breadcrumb",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://ptsupersoft.com/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Help",
                  "item": "https://ptsupersoft.com/help"
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "Contact",
                  "item": "https://ptsupersoft.com/help/contact"
                }
              ]
            },

            {
              "@type": "FAQPage",
              "@id": "https://ptsupersoft.com/help/contact/#faq",
              "inLanguage": ["en", "id"],
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "How can I contact PT Supersoft Sistemindo?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You can contact us through the form on this page or email us at info@ptsupersoft.com."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Produk apa saja yang disediakan PT Supersoft Sistemindo?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Kami menyediakan solusi Infor SunSystems, Hexagon EAM, enterprise applications, dan layanan konsultasi IT sesuai kebutuhan bisnis Anda."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you provide online or on-site consultation?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we provide both online and on-site consultations depending on your project requirements."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Berapa lama waktu respons setelah saya menghubungi Anda?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Tim kami biasanya merespons dalam waktu 1×24 jam pada hari kerja."
                  }
                }
              ]
            }

          ]
        }
      `}</script>
      </Helmet>
      <div
        className="w-full min-h-[430px]"
        style={{
          backgroundImage: `url(${background && background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="section-container w-full min-h-[430px] flex flex-col justify-center items-center space-y-[16px] text-center">
          <h1 className="header-style-hero mdl:text-[50px] text-[42px] text-white mt-[70px]">
            {title && title}
          </h1>
          {summary && (
            <h1 className="content-subheader-style-non-hero-non-prose !font-inter text-white max-w-[670px]">
              {summary}
            </h1>
          )}
        </div>
      </div>
    </>
  );
}

export default SSoft_Help_Hero;
